import { useState, useEffect, useRef } from 'react';
import { ContentContainer, Input, Label, Select, Option } from '../../../../../styles/component.styles';
import AccordionSection from '../../../../reusable/accordion-section/accordion-section.component';

const YouTubeAddSection = ({ onChange }) => {
  const [youtubeUrl, setYoutubeUrl] = useState('');

  // Style options
  const [align, setAlign] = useState('center');
  const [background, setBackground] = useState('transparent');
  const [padding, setPadding] = useState('2rem 0');
  const [margin, setMargin] = useState('2rem 0');

  const prev = useRef({});

  useEffect(() => {
    const content = { youtubeUrl };
    const metadata = { align, background, padding, margin };
    const current = JSON.stringify({ content, metadata });

    if (prev.current !== current) {
      prev.current = current;
      onChange({ content, metadata });
    }
  }, [youtubeUrl, align, background, padding, margin, onChange]);

  return (
    <>
      <Label>YouTube Video URL</Label>
      <Input
        value={youtubeUrl}
        onChange={(e) => setYoutubeUrl(e.target.value)}
        placeholder="https://www.youtube.com/watch?v=..."
      />

      {/* <AccordionSection title="Advanced Style Options">
        <ContentContainer>
          <Label>Alignment</Label>
          <Select value={align} onChange={(e) => setAlign(e.target.value)}>
            <Option value="left">Left</Option>
            <Option value="center">Center</Option>
            <Option value="right">Right</Option>
          </Select>

          <Label>Background Color</Label>
          <Input
            type="text"
            value={background}
            onChange={(e) => setBackground(e.target.value)}
            placeholder="e.g. #f0f0f0 or transparent"
          />

          <Label>Padding</Label>
          <Input
            type="text"
            value={padding}
            onChange={(e) => setPadding(e.target.value)}
            placeholder="e.g. 2rem 0"
          />

          <Label>Margin</Label>
          <Input
            type="text"
            value={margin}
            onChange={(e) => setMargin(e.target.value)}
            placeholder="e.g. 2rem 0"
          />
        </ContentContainer>
      </AccordionSection> */}
    </>
  );
};

export default YouTubeAddSection;